/* LAYOUT */
export const BOOKING_LIST_LOADING = 'BOOKING_LIST_LOADING';
export const BOOKING_LIST_DATA = 'BOOKING_LIST_DATA';
export const BOOKING_LIST_FAILED = 'BOOKING_LIST_FAILED';

export const GET_BOOKING_DETAIL_DATA_LOADING = 'GET_BOOKING_DETAIL_DATA_LOADING';
export const GET_BOOKING_DETAIL_DATA_SUCCESS = 'GET_BOOKING_DETAIL_DATA_SUCCESS';
export const GET_BOOKING_DETAIL_DATA_FAILED = 'GET_BOOKING_DETAIL_DATA_FAILED';

export const BOOKING_FILTER_DATA_VALUES = 'BOOKING_FILTER_DATA_VALUES';
export const BOOKING_FILTER_DATA_LOADING = 'BOOKING_FILTER_DATA_LOADING';
export const BOOKING_FILTER_DATA_FAILED = 'BOOKING_FILTER_DATA_FAILED';

export const CONTAINERS_LIST_LOADING = 'CONTAINERS_LIST_LOADING';
export const CONTAINERS_LIST_DATA = 'CONTAINERS_LIST_DATA';
export const CONTAINERS_LIST_FAILED = 'CONTAINERS_LIST_FAILED';

export const BOOKING_DOCUMENT_LOADING = 'BOOKING_DOCUMENT_LOADING';
export const BOOKING_DOCUMENT_DATA = 'BOOKING_DOCUMENT_DATA';
export const BOOKING_DOCUMENT_FAILED = 'BOOKING_DOCUMENT_FAILED';
